import React from 'react';
import cx from 'classnames';

const DependentsShow = function (props: {
  isShow?: boolean;
  children: React.ReactNode;
}) {
  const { isShow, ...rest } = props
  return (
    <div
      className={cx(
        'pt-[15px] pb-[10px] px-0',
        'border-t border-t-[#e9eced] first:border-t-0',
        isShow ? 'flex' : 'hidden',
      )}
      {...rest}
    />
  );
};

export default DependentsShow;
